import React, { FC } from "react";

import { useLabels } from "../Hooks/useLabels";

import { FourthStepInfoContainer } from "../FormElements";
import { SvgIcon } from "../../SvgIcon/SvgIcon";
import { LocationDto } from "../../../../Api/Model/LocationDto.csharp";
import { CreateBookingResponseDto } from "../../../../Api/Model/CreateBookingResponseDto.csharp";

type CenterInformationType = {
  bookingResponse: CreateBookingResponseDto;
  centerName: string;
};

export const CenterInformation: FC<CenterInformationType> = ({
  bookingResponse,
  centerName,
}) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;

  const phoneNumber = bookingResponse.centerPhoneNumber?.trim();
  const mapURLSearch = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    `${bookingResponse.centerAddressLine1},${bookingResponse.centerAddressLine2}` ??
      ""
  )}`;

  return (
    <FourthStepInfoContainer>
      <h3>{fourthStepLabels?.centerDetailsHeading ?? "Finn frem"}</h3>
      <p className="my-0">{centerName}</p>
      <a href={`${mapURLSearch}`} className="mb-0 underline">
        {bookingResponse.centerAddressLine1}
        <br />
        {bookingResponse.centerAddressLine2}
      </a>
      {bookingResponse.centerPhoneNumber && (
        <div className="d-flex my-2">
          <SvgIcon className="icon-sm" iconName="ic-phone" />
          <a href={`tel: ${phoneNumber}`} className="mx-1 underline">
            {phoneNumber}
          </a>
        </div>
      )}
      {bookingResponse.centerSummary && (
        <div
          dangerouslySetInnerHTML={{ __html: bookingResponse.centerSummary }}
        />
      )}
    </FourthStepInfoContainer>
  );
};
